// GENERATED BY portal-gen — DO NOT EDIT.
//
// Source: Metrics API (via the Edge) — metrics-api.v1.yaml
// Regenerate with `npm run generate`; `npm run check` byte-diffs this file against a
// fresh run and fails the build on any difference.
//
// Every object below preserves the contract's `additionalProperties: false` as `.strict()`.
// That is a privacy control, not a typing convenience: a control-plane response that ever
// grows a content-bearing field must fail to parse, not render.

import { z } from "zod";



// ---- Operations ----
//
// `roleGate` is documentation carried into the type system, NOT enforcement. It lets a
// lint test assert that every admin-gated call site sits inside a RequireAdmin subtree,
// and it lets the client attach the right context to a 403.

/** Self-scoped usage widgets for the Account Portal. Always the caller's own usage. */
export const getPortalUsage = {
  id: "getPortalUsage",
  method: "GET",
  path: "/v1/portal/usage",
  roleGate: "any",
  pathParams: [] as const,
  queryParams: {
    from: { required: true },
    to: { required: true },
  } as const,
  requiresIfMatch: false,
  request: null,
  successStatus: 200,
  response: z.object({
  scope: z.object({
    role: z.enum(["company_admin", "agency_admin", "super_admin", "member"]),
    orgIds: z.union([z.array(z.string()), z.literal("*")]),
    portfolio: z.boolean(),
  }).strict(),
  range: z.object({
    from: z.string(),
    to: z.string(),
    granularity: z.enum(["day", "week", "month"]),
  }).strict(),
  usage: z.object({
    prompts_this_week: z.number().int(),
    redactions_applied: z.number().int(),
    stored_bytes: z.literal(0),
    storage_by_design: z.literal(true),
  }).strict(),
}).strict(),
  errors: [401, 403] as const,
} as const;
export type GetPortalUsageResponse = z.infer<typeof getPortalUsage.response>;

export const metricsOperations = { getPortalUsage } as const;
